import {Avatar, Box, Typography} from '@mui/material';
import './occurrence-card.scss';
import moment from 'moment';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../i18n/translations';
import {OccurrenceStatus} from '../../../screens/private/office/professional-caregiver/occurrences/occurrences.professional-caregiver.screen';
import {OccurrenceStatus as OccurrencesCardStatus} from '../../../screens/private/office/professional-caregiver/occurrences/occurrences-status';

type OccurrenceCard = {
  id: string;
  type: string;
  name: string;
  picture: string;
  borderColor: string;
  date: Date;
  status: OccurrenceStatus;
  onSelect: (id: string) => void;
};

export default function DailyCareLogOccurrenceCard({
  id,
  type,
  name,
  picture,
  borderColor,
  date,
  status,
  onSelect,
}: OccurrenceCard) {
  const {t} = useTranslation();

  return (
    <Box onClick={() => onSelect(id)} className="daily-occurrence-card">
      <Box className="card-senior-container">
        <Avatar
          src={picture}
          sx={{
            width: '38px',
            height: '38px',
            border: `1.2px solid ${borderColor || 'transparent'}`,
          }}
        />
      </Box>
      <Box className="card-occurrence-container">
        <div className="name-type">
          {name && <Typography className="name">{name}</Typography>}
          {name && type && <span>-</span>}
          {type && <Typography className="type">{type}</Typography>}
        </div>
        <Typography className="date">{`${moment(date).format('DD/MM')} ${t(translations.schedule_field.readable_periodicity.at_hour)} ${moment(date).format('HH:mm')}`}</Typography>
      </Box>
      <Box className="card-actions-container">
        <OccurrencesCardStatus status={status} />
      </Box>
    </Box>
  );
}
